const doc = [({"ja":({"adminConstantHotelDisplayPriceType":({"totalPriceOnly":"合計料金のみ", "totalAndPricePerPerson":"合計料金と一人当たりの料金"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;